<template>
  <div class="business-equipmentlist">
    <h2 class="top-title">版本更新记录</h2>
    <!-- <Card dis-hover> -->
    <!-- v-if='dataLists.length' -->
    <div class="lists clearfix list-margin">
      <Button @click="addBtn" type="primary">
        <Icon type="md-add" />新增版本更新记录</Button
      >
      <!-- 列表 -->
      <div class="common-list table-margin">
        <Table
          class="equipmentTable"
          :columns="dataColumn"
          :data="dataLists"
        ></Table>
      </div>
      <div class="common-page fr">
        <Page
          show-total
          show-elevator
          show-sizer
          :total="total"
          :current="pageInfo.current"
          :page-size="pageInfo.size"
          @on-change="getList"
          @on-page-size-change="getListsSize"
        >
        </Page>
      </div>
    </div>
    <!-- </Card> -->

    <!-- 新增编辑 -->
    <VersionModal
      :editData="editData"
      :title="title"
      :showModal="addModal"
      @success="update"
      @close="closeModal"
    ></VersionModal>
  </div>
</template>
  
  <script>
import api from "@/api";
import sizeData from "@/mixins/sizeData";
import handleSelItem from "@/mixins/handleSelItem";
import toRoleName from "@/mixins/roleName";
import VersionModal from "./components/version-modal";
import ls from "store2";
import Base64 from "@/util/encryptlong";
import { mapState } from "vuex";
export default {
  name: "versionRecord",
  mixins: [handleSelItem, sizeData, toRoleName],
  computed: {},
  components: {
    VersionModal,
  },
  data() {
    return {
      editData: {},
      title: "新增版本更新记录",
      addModal: false,
      userInfo:  JSON.parse(Base64.decode(ls.page("userInfo"))) || {},
      userRole: null,
      dataLists: [],
      pageInfo: {
        current: 1,
        size: 10,
      },
      total: 0,
      dataColumn: [
        {
          title: "序号",
          type: "index",
        },
        {
          title: "版本号",
          key: "code",
          align: "left",
          render: (h, params) => {
            const item = params.row;
            return h("div", item.code || "-");
          },
        },
        {
          title: "版本更新内容",
          key: "content",
          align: "left",
          render: (h, params) => {
            const item = params.row;
            return h(
              "div",
              // { class: "comment  tab-linheight version" },
               { class: "comment version tab-linheight" },
              item.content || "-"
            );
          },
        },
        {
          title: "版本更新记录状态",
          key: "publishCode",
          align: "left",
          render: (h, params) => {
            const item = params.row;
            return h("div", [
              h("Icon", {
                props: {
                  type: item.publishCode ? "md-checkmark" : "md-remove-circle",
                },
                style: {
                  fontSize: "16px",
                  color: item.publishCode ? "#1E8E3E" : "#C1C1C1",
                },
              }),
              h(
                "span",
                {
                  style: {
                    marginLeft: "8px",
                  },
                },
                item.publishCode == 1 ? "已发布" : "未发布"
              ),
            ]);
          },
        },
        {
          title: "版本更新时间",
          key: "versionModifiedReal",
          align: "left",
          render: (h, params) => {
            const item = params.row;
            return h("div", item.versionModifiedReal || "-");
          },
        },
        {
          title: "操作",
          key: "address",
          align: "left",
          className: "action",
          render: (h, params) => {
            const item = params.row;
            return h("div", [
              h(
                "span",
                {
                  props: {
                    size: "small",
                  },
                  style: {
                    color: "#0c479d",
                    cursor: "pointer",
                    display: item.publishCode ? "none" : "inline-block",
                  },
                  on: {
                    click: () => {
                      this.publish(params.row);
                    },
                  },
                },
                "发布"
              ),
              h(
                "span",
                {
                  style: {
                    color: "#ddd",
                    margin: "0 10px",
                    verticalAlign: "middle",
                    display: item.publishCode ? "none" : "inline-block",
                  },
                },
                "|"
              ),
              h(
                "span",
                {
                  props: {
                    size: "small",
                  },
                  style: {
                    color: "#0C479DFF",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.edit(params.row);
                    },
                  },
                },
                "编辑"
              ),
              h(
                "span",
                {
                  style: {
                    color: "#ddd",
                    margin: "0 10px",
                    verticalAlign: "middle",
                  },
                },
                "|"
              ),
              h(
                "span",
                {
                  props: {
                    size: "small",
                  },
                  style: {
                    color: "#0C479DFF",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.delete(params.row);
                    },
                  },
                },
                "删除"
              ),
            ]);
          },
        },
      ],
    };
  },
  created() {},
  mounted() {
    this.getList();
  },
  methods: {
    getList(page) {
      this.$store.state.spinShow = true;
      if (page) this.pageInfo.current = page; //分页处理

      api
        .axss("post", "/ocm-oil-site/oil-site-publish-version/page", {
          ...this.pageInfo,
        })
        .then((res) => {
          if (res.code === "00000") {
            this.dataLists = res.data.records;
            this.$store.state.spinShow = false;
            this.total = res.data.total;
            // this.$nextTick(() => {
            //   var popup = document.getElementsByClassName("version");
            //   for (let index in popup) {
            //     let row = popup[index];
              
            //      const containerHeight = row.clientHeight;
            //      if(containerHeight&&containerHeight>22){
            //         row.style.padding="10px 0"
            //      }
               
            //   }
            // });
          }
        })
        .catch((res) => {
          this.$store.state.spinShow = false;
        });
    },
    addBtn() {
      this.title = "新增版本更新记录";
      this.addModal = true;
    },
    getListsSize(size) {
      this.pageInfo.size = size;
      this.getList(1);
    },
    update() {
      this.addModal = false;
      this.getList();
    },
    closeModal() {
      this.addModal = false;
    },
    publish(value) {
      this.$Modal.confirm({
        title: `确定发布该条版本更新记录吗？版本更新记录一经发布，将所有人可见，且不可撤回。`,
        onOk: () => {
          this.published(value);
        },
        onCancel: () => {},
      });
    },
    published(value) {
      api
        .axss(
          "get",
          `/ocm-oil-site/oil-site-publish-version/publish?id=${value.id}`
        )
        .then((res) => {
          if (res.code === "00000") {
            this.$Message.success("发布成功");
            this.getList(this.pageInfo.current);
            this.$nextTick(() => {
              this.$store.dispatch("pub/SET_VERSION");
            });
          }
        });
    },
    delete(value) {
      this.$Modal.confirm({
        title: `确定删除该条版本更新记录吗？`,
        content: `用户组名称：${value.code}`,
        onOk: () => {
          this.delItem(value);
        },
        onCancel: () => {},
      });
    },
    delItem(value) {
      api
        .axss(
          "get",
          `/ocm-oil-site/oil-site-publish-version/del?id=${value.id}`
        )
        .then((res) => {
          if (res.code === "00000") {
            this.$Message.success("删除成功");
            const finalSize = this.sizeData(
              this.pageInfo.size,
              this.pageInfo.current,
              this.total
            );
            this.getList(finalSize);
          }
        });
    },
    edit(value) {
      this.addModal = true;
      this.title = "编辑版本更新记录";
      this.editData = {
        id: value.id,
        code: value.code,
        content: value.content,
        gmtRealCreate: value.gmtRealCreate,
      };
    },
  },
};
</script>
  
  <style lang='less' scoped>
.business-equipmentlist {
  .lists {
    margin-top: 20px;
  }
}
</style>
<style>
.ivu-modal-confirm-head {
  display: flex !important;
}
.ivu-modal-confirm-head-title {
  padding-top: 8px;
}
.comment {
  white-space: pre-wrap;
}
</style>